import { useLazyQuery, useQuery } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import moment from 'moment';
import 'moment/locale/es';
import { CustomChip } from '../../../components/chip/Chip';
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import { DateInput } from '../../../components/dateInput/DateInput';
import './contratosAll.scss';

import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { GET_CONTRATOS_SEARCH } from '../../../data/graphQL/queries/Contratos/getContratosSearch';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { CustomButton } from '../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { adaptEstadosContratoArray, GET_ESTADOS_CONTRATO } from '../../../data/graphQL/queries/Contratos/getEstadosEvaluacion';
import { downloadExcel } from '../../../utils/downloadExcel';
import { formatCurrency } from "../../../utils/mathUtils";

export const ContratosAll = ({ setChildrenAction }) => {

  const storageId = sessionStorage.getItem('idUsuario');
  const header = ["Origen", "#", "Nombre", "Apellido", "Cliente", "Plan", "Fecha Ingreso", "Fecha Desde", "Fecha Hasta", "Precio", "Crediticia", "Profesional", "Presupuesto", "Paciente"];
  const FILE_TYPE = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  const ESTADO_AP = "AP";
  const ESTADO_CO = "CO";
  const ESTADO_NA = "NA";
  const ESTADO_NI = "NI";
  const ESTADO_PE = "PE";
  const ESTADO_PO = "PO";
  const ESTADO_PN = "PN";
  const ESTADO_RE = "RE";
  const ESTADO_AT = "AT";
  const ESTADO_SA = "SA";
  const ESTADO_SE = "SE";
  const ESTADO_SU = "SU";
  const ESTADO_NOING = "NOING";

  const ESTADO_CONTRATO_APROBADO = 'AP';
  const ESTADO_CONTRATO_RECHAZADO = 'RE';
  const ESTADO_CONTRATO_CANCELADO = 'CA';

  const navigate = useNavigate();
  const location = useLocation();
  const rutasStorage = localStorage.getItem('navigationRoutes');
  const [allowedWrite, setAllowedWrite] = useState(false);
  const [contratos, setContratos] = useState([]);
  const [datosOriginal, setDatosOriginal] = useState([]);
  const [delegaciones, setDelegaciones] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [estadosContrato, setEstadosContrato] = useState([]);
  let dataExport = [];

  const { filters, handleChangeFilters } = usePersistFilters({
    idDelegacion: delegacionOrigen,
    fechaDesde: moment().add(-10, 'd').format("yyyy-MM-DD"),
    fechaHasta: moment().add(20, 'd').format("yyyy-MM-DD"),
    idServicio: 1,
    idTipoContrato: 2,
    txtFiltro: ''
  }, "contratosAllFilters");

  const { data: dataEstadosContrato } = useQuery(GET_ESTADOS_CONTRATO);

  useEffect(() => {
    if (!dataEstadosContrato) return;
    setEstadosContrato(adaptEstadosContratoArray(dataEstadosContrato));
  }, [dataEstadosContrato]);


  const [getDelegacionOrigen, { data: dataDelegacionOrigen, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegacionOrigen) return;
    if (dataDelegacionOrigen.usuarioFull.success) {
      const deleg = parseInt(dataDelegacionOrigen.usuarioFull.valorEsperado.delegacionOrigen, 10);
      setDelegacionOrigen(deleg);
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });

      if (filters.idDelegacion == 0)
        handleChangeFilters('idDelegacion', deleg);
    }
  }, [dataDelegacionOrigen]);

  const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    setDelegaciones(adaptDelegacionArray(dataDelegaciones));
  }, [dataDelegaciones]);

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;

      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);
    }
  }, [rutasStorage]);

  const buttonActionLoading = useMemo(() =>
    delegacionesLoading ||
    !delegacionesLoading && !delegaciones?.length ||
    delegacionOrigenLoading,
    [
      delegacionesLoading,
      delegacionOrigenLoading,
      delegaciones]
  );
  useEffect(() => {
    setChildrenAction(() =>
      <div className='top-buttons'>
        <CustomButton
          isLoading={buttonActionLoading}
          variant='outlined'
          className='margin-right'
          onClick={handleExportar}>

          Exportar
        </CustomButton>
        {allowedWrite && <>
          <CustomButton
            isLoading={buttonActionLoading}
            className='margin-right'
            onClick={() => navigate('/contratos/crearContrato',
              {
                state: {
                  origen: 'PE',
                  idEvaluacion: 0,
                  edit: true,
                  nuevoPaciente: false,
                  nuevoPacienteExistente: true,
                  delegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.displayName,
                  idDelegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.id,
                  codigoDelegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.cod
                }
              })}>

            Paciente Existente
          </CustomButton>
          <CustomButton
            isLoading={buttonActionLoading}
            onClick={() => navigate('/contratos/crearContrato',
              {
                state: {
                  origen: 'PP',
                  idEvaluacion: 0,
                  edit: true,
                  nuevoPaciente: true,
                  nuevoPacienteExistente: false,
                  delegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.displayName,
                  idDelegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.id,
                  codigoDelegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.cod
                }
              })}>

            Nuevo Paciente
          </CustomButton>
        </>}
      </div>
    );

  }, [setChildrenAction, allowedWrite, buttonActionLoading, filters?.idDelegacion, contratos, delegaciones]);

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    }
  }, []);

  useEffect(() => {
    if (!contratosLoading && delegacionOrigen > 0) {
      getContratos({
        variables: {
          filter: {
            fechaDesde: filters?.fechaDesde,
            fechaHasta: filters?.fechaHasta,
            idDelegacion: filters?.idDelegacion,
            idServicio: filters?.idServicio,
            idTipoContrato: filters?.idTipoContrato
          }
        }
      });
    }
  }, [delegacionOrigen]);

  useEffect(() => {
    handleTextFilter();
  }, [datosOriginal]);

  const handleExportar = () => {
    dataExport = [];
    for (var i = 0; i < contratos.length; i++) {
      let nodo = contratos[i];
      dataExport.push({
        origen: nodo.tipo,
        idEvaluacion: parseInt(nodo.idEvaluacion, 10) > 0 ? nodo.idEvaluacion : '',
        nombre: nodo.nombre,
        apellido: nodo.apellido,
        cliente: nodo.razonSocial,
        plan: nodo.descPlan || '',
        fechaAlta: moment(nodo.fechaAlta).year() > 2000 ? moment(nodo.fechaAlta).format('DD/MM/yyyy') : '',
        fechaDesde: moment(nodo.fechaDesde).year() > 2000 ? moment(nodo.fechaDesde).format('DD/MM/yyyy') : '',
        fechaHasta: moment(nodo.fechaHasta).year() > 2000 ? moment(nodo.fechaHasta).format('DD/MM/yyyy') : '',
        precio: parseFloat(nodo.precioDiario) > 0 ? '$ ' + nodo.precioDiario : '',
        crediticia: nodo.estadoCrediticioE,
        profesional: nodo.estadoProfesionalE,
        presupuesto: nodo.estadoEvaluacionComercial,
        paciente: nodo.estadoPaciente
      });
    }
    if (dataExport.length > 0) {
      downloadExcel({
        fileName: 'GestionContratos',
        sheet: "Contratos",
        tablePayload: {
          header,
          body: dataExport
        }
      });
    }
  };

  const handleChangeFechaDesde = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : "";
    handleChangeFilters("fechaDesde", nuevaFecha);
  };

  const handleChangeFechaHasta = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : "";
    handleChangeFilters("fechaHasta", nuevaFecha);
  };

  const [getContratos, { data: dataContratos, loading: contratosLoading }] = useLazyQuery(GET_CONTRATOS_SEARCH, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataContratos) return;
    setContratos(dataContratos.contratosSearch.valorEsperado);
    setDatosOriginal(dataContratos.contratosSearch.valorEsperado);
  }, [dataContratos]);


  const handleTextFilter = () => {
    const inputBuscar = filters?.txtFiltro?.toUpperCase()?.trim();

    if (inputBuscar?.length >= 2) {
      setContratos(datosOriginal?.filter((datoOriginal) => {
        const contratoBuscar = datoOriginal.idEvaluacion != '' ? datoOriginal.idEvaluacion.toString().toUpperCase() : '';
        const nombrePacienteBuscar = datoOriginal.nombre.toUpperCase();
        const apellidoPacienteBuscar = datoOriginal.apellido.toUpperCase();
        const clienteBuscar = datoOriginal.razonSocial.toUpperCase();
        const planBuscar = datoOriginal.descPlan != '' && datoOriginal.descPlan != null ? datoOriginal.descPlan.toUpperCase() : '';

        return (
          contratoBuscar.includes(inputBuscar) ||
          nombrePacienteBuscar.includes(inputBuscar) ||
          apellidoPacienteBuscar.includes(inputBuscar) ||
          clienteBuscar.includes(inputBuscar) ||
          planBuscar.includes(inputBuscar));

      }));
    } else {
      setContratos(datosOriginal);
    }
  };

  const handleTextClean = () => {
    handleChangeFilters('txtFiltro', '');
    setContratos(datosOriginal);
  };

  const handleClickEdit = (row) => {
    const delegacionActual = delegaciones?.find((x) => x.id === row.idDelegacion);

    navigate('/contratos/crearContrato',
      {
        state: {
          idEvaluacion: row.idEvaluacion,
          idDelegacion: row.idDelegacion,
          delegacion: delegacionActual?.displayName,
          codigoDelegacion: delegacionActual?.cod,
          origen: row.tipo,
          edit: true,
          nuevoPaciente: false,
          nuevoPacienteExistente: false,
          descEstadoEvaluacion: row.descEstadoEvaluacion,
          idEstadoEvaluacion: row.idEstadoEvaluacion,
          idPrePaciente: row.idPrePaciente
        }
      }
    );
  };


  const handleView = (row) => {
    const delegacionActual = delegaciones?.find((x) => x.id === row.idDelegacion);

    navigate('/contratos/crearContrato',
      {
        state: {
          idEvaluacion: row.idEvaluacion,
          idDelegacion: row.idDelegacion,
          delegacion: delegacionActual?.displayName,
          codigoDelegacion: delegacionActual?.cod,
          origen: row.tipo,
          edit: false,
          nuevoPaciente: false,
          nuevoPacienteExistente: false,
          descEstadoEvaluacion: row.descEstadoEvaluacion,
          idEstadoEvaluacion: row.idEstadoEvaluacion,
          idPrePaciente: row.idPrePaciente,
          allowedWrite: allowedWrite
        }
      }
    );
  };

  const getChipEstado = (estado, diasCO = null) => {
    switch (estado) {
      case ESTADO_PE:
        return (
          <CustomChip label={estado} isYellow title='Pendiente' />);

      case ESTADO_CO:
        const title = diasCO == null ? 'Condicional' : 'Condicional' + ' (' + diasCO + ' días)';
        return (
          <CustomChip label={diasCO == null ? estado : estado + ' (' + diasCO + ')'} isViolet title={title} />);

      case ESTADO_PO:
        return (
          <CustomChip label={estado} isYellow title='Paciente probable' />);

      case ESTADO_SA:
        return (
          <CustomChip label={estado} isGreen title='Satisfactorio' />);

      case ESTADO_SE:
        return (
          <CustomChip label={estado} isGreen title='Paciente servicio' />);

      case ESTADO_AP:
        return (
          <CustomChip label={estado} isGreen title='Aprobado' />);

      case ESTADO_PN:
        return (
          <CustomChip label={estado} isGray title='Paciente nuevo' />);

      case ESTADO_NA:
        return (
          <CustomChip label="N/A" isGray title='No aplica' />);

      case ESTADO_SU:
        return (
          <CustomChip label={estado} isRed title='Suspendido' />);

      case ESTADO_NI:
        return (
          <CustomChip label={estado} isViolet title='No iniciado' />);

      case ESTADO_NOING:
        return (
          <CustomChip label="NI" isRed title='No ingreso' />);

      case ESTADO_RE:
        return (
          <CustomChip label={estado} isRed title='Rechazado' />);

      case ESTADO_AT:
        return (
          <CustomChip label={estado} isRed title='AT' />);

      default: return;
    }
  };

  const showByState = (row) => {
    const estadoAprobadoId = estadosContrato?.find((x) => x.codigo === ESTADO_CONTRATO_APROBADO)?.id;
    const estadoRechazadoId = estadosContrato?.find((x) => x.codigo === ESTADO_CONTRATO_RECHAZADO)?.id;
    const estadoCanceladoId = estadosContrato?.find((x) => x.codigo === ESTADO_CONTRATO_CANCELADO)?.id;
    return !(row.idEstadoEvaluacion === estadoAprobadoId && row.estadoEvaluacionComercial === 'AP' ||
      row.idEstadoEvaluacion === estadoRechazadoId ||
      row.idEstadoEvaluacion === estadoCanceladoId);
  };

  const getDescriptionTooltipOrigen = (origen) => {
    switch (origen) {
      case "PP":
        return "Paciente Probable";
      case "PE":
        return "Paciente Existente";
      case "PR":
        return "Prórroga";
      case "US":
        return "Derivado de Unidad de Soporte";
      default:
        return "";
    }
  };

  const mapEstadoProfesionalE = (id) => {
    switch (id) {
      case '1':
        return 'PE'; // Pendiente
      case '2':
        return 'AP'; // Aprobado
      case '3':
        return 'RE'; // Rechazado
      default:
        return 'PE'; // Si no coincide, devolvemos "PE"
    }
  };
  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      cellClassName: 'grid-actions-column',
      minWidth: 35,
      maxWidth: 35,
      width: 35,
      renderCell: (cellProps, v, f) => {
        const { row } = cellProps;

        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                {
                  allowedWrite &&
                  showByState(row) &&
                  <div
                    aria-hidden='true'
                    onClick={() => handleClickEdit(row)}
                    className='item-option clickable-option'
                  >
                    <EditIcon className='edit-icon' />
                    <span className='toggle-action'>Editar</span>
                  </div>
                }
                <div aria-hidden='true' onClick={() => handleView(row)}
                  className='item-option clickable-option'>
                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver</span>
                </div>
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'tipo',
      headerName: 'Origen',
      width: 65,
      renderCell: (cellProps) => {
        const { value: tipo } = cellProps;
        return <Tooltip title={getDescriptionTooltipOrigen(tipo)} placement="bottom"><>{tipo}</></Tooltip>;
      }
    },
    {
      field: 'idEvaluacion',
      headerName: '#',
      width: 65,
      valueGetter: (idEvaluacion) => {
        if (parseInt(idEvaluacion, 10) > 0) {
          return idEvaluacion;
        }
      }
    },
    {
      field: 'nombre',
      headerName: 'Nombre',
      width: 130
    },
    {
      field: 'apellido',
      headerName: 'Apellido',
      width: 140
    },
    {
      field: 'razonSocial',
      headerName: 'Cliente',
      width: 210
    },
    {
      field: 'descPlan',
      headerName: 'Plan',
      width: 240
    },
    {
      field: 'fechaAlta',
      headerName: 'F. Ingreso',
      type: 'date',
      width: 80,
      limitDate: 2000
    },
    {
      field: 'fechaDesde',
      headerName: 'F. Desde',
      type: 'date',
      width: 80,
      limitDate: 2000
    },
    {
      field: 'fechaHasta',
      headerName: 'F. Hasta',
      type: 'date',
      width: 80,
      limitDate: 2000
    },
    {
      field: 'precioDiario',
      headerName: 'Precio',
      width: 80,
      valueGetter: (precioDiario) => formatCurrency(precioDiario)
    },
    {
      field: 'estadoCrediticioE',
      headerName: 'Crediticia',
      width: 85,
      align: 'center',
      headerAlign: 'center',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        if (!row.estadoCrediticioE)
          return getChipEstado("PE"); else

          return getChipEstado(row.estadoCrediticioE);
      }
    },
    {
      field: 'estadoProfesionalE',
      headerName: 'Profesional',
      width: 90,
      headerAlign: 'center',
      align: 'center',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        if (!row.estadoProfesionalE)
          return getChipEstado("PE"); else

          return getChipEstado(row.estadoProfesionalE);
      }
    },
    {
      field: 'estadoEvaluacionComercial',
      headerName: 'Presupuesto',
      width: 110,
      align: 'center',
      headerAlign: 'center',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        if (!row.estadoEvaluacionComercial)
          return getChipEstado("PE"); else

          return getChipEstado(row.estadoEvaluacionComercial, row.diasCO);
      }
    },
    {
      field: 'estadoPaciente',
      headerName: 'Paciente',
      width: 85,
      align: 'center',
      headerAlign: 'center',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const tieneNIngreso = !!row.idNIngreso;
        return getChipEstado(tieneNIngreso ? 'NOING' : row.estadoPaciente);
      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [allowedWrite, delegaciones, estadosContrato]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    handleChangeFilters(name, value);
  };

  const filtrosValidos = () => {
    if (filters.fechaDesde == "") {
      toast.error("La Fecha Desde es obligatoria.");
      return false;
    }
    if (filters.fechaHasta == "") {
      toast.error("La Fecha Hasta es obligatoria.");
      return false;
    }
    if (filters.fechaHasta < filters.fechaDesde) {
      toast.error("La Fecha Hasta no puede ser anterior a la Fecha Desde.");
      return;
    }
    return true;
  };

  const handleSearch = () => {
    if (!contratosLoading && filtrosValidos()) {
      getContratos({
        variables: {
          filter: {
            fechaDesde: filters?.fechaDesde,
            fechaHasta: filters?.fechaHasta,
            idDelegacion: filters?.idDelegacion,
            idServicio: filters?.idServicio,
            idTipoContrato: filters?.idTipoContrato
          }
        }
      });
    }
  };

  return (
    <div className='general'>
      <Grid
        container
        spacing={2}
        sx={{ marginBottom: '25px' }}>

        <Grid size={{
          xs: 12,
          md: 4,
          xl: 2.5,
        }}>
          <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
            <InputLabel id="select-delegacion">Delegación</InputLabel>
            <Select
              labelId="select-delegacion"
              options={delegaciones}
              label='Delegación'
              onChange={handleChange}
              value={filters?.idDelegacion}
              name='idDelegacion'>

              {delegaciones && delegaciones.map((delegacion) => {
                return <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{
          xs: 12,
          md: 4,
          xl: 2,
        }}>
          <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
            <InputLabel id="select-idTipocontrato">Tipo de Contrato</InputLabel>
            <Select
              labelId="select-idTipocontrato"
              // options={delegaciones}
              label='Tipo de Contrato'
              onChange={handleChange}
              value={filters?.idTipoContrato}
              name='idTipoContrato'>

              <MenuItem value={0}>Todos</MenuItem>
              <MenuItem value={2}>PP - Paciente Probable</MenuItem>
              <MenuItem value={1}>PE - Paciente Existente</MenuItem>
              <MenuItem value={3}>PR - Prórroga</MenuItem>
              <MenuItem value={4}>US - Derivado de US</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{
          xs: 12,
          md: 4,
          xl: 2.7,
        }}>
          <TextField
            label="Filtrar"
            name="txtFiltro"
            size="small"
            type="text"
            variant="outlined"
            value={filters?.txtFiltro}
            onChange={(e) => handleChangeFilters('txtFiltro', e.target.value)}
            onKeyUp={handleTextFilter}
            sx={{ backgroundColor: 'white' }}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleTextFilter}
                    sx={{ cursor: 'pointer' }} />

                  <ClearIcon
                    onClick={handleTextClean}
                    sx={{ cursor: 'pointer' }} />

                </InputAdornment>

            }} />

        </Grid>
        <Grid size={{
          xs: 12,
          md: 4,
          xl: 1.8,
        }}>
          <DateInput
            label="Fecha Desde"
            value={filters?.fechaDesde}
            onChange={handleChangeFechaDesde} />

        </Grid>
        <Grid size={{
          xs: 12,
          md: 4,
          xl: 1.8,
        }}>
          <DateInput
            label="Fecha Hasta"
            value={filters?.fechaHasta}
            onChange={handleChangeFechaHasta} />

        </Grid>
        <Grid sx={{ textAlign: 'right' }} size={{
          xs: 12,
          md: 4,
          xl: 1.2,
        }}>
          <CustomButton
            variant='contained'
            className='margin-right'
            onClick={handleSearch}
            size='small'>

            Buscar
          </CustomButton>
        </Grid>
      </Grid>

      <DataGridGenerico
        columns={columns}
        rows={contratos ?? []}
        toolbar={false}
        loading={contratosLoading}
        totalCount={contratos?.length}
        maxWidth={columns.reduce((total, column) => total + (column.width || 0), 0)} />

    </div>);

};